function Title() {
    return (
        <section>
            <h2>SpotiGuessr</h2>
            
        </section>

    );
}

export default Title;